<template>
  <div>
    <transition name="screen" mode="out-in">
      <PrivateLobby v-if="isPrivateGame" />
      <PublicLobby v-else />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { useGameStore } from '@/stores/game'
import { computed } from 'vue'
import PublicLobby from '@/components/screens/game-intro/lobbies/PublicLobby.vue'
import PrivateLobby from '@/components/screens/game-intro/lobbies/PrivateLobby.vue'

const gameStore = useGameStore()
const gameState = computed(() => gameStore.gameState)

const isPrivateGame = computed(() => Boolean(gameState.value?.code))
</script>

<style scoped></style>
